import WorkflowToken from '@apps/automation/admin/tokens/workflow'
import New from '@apps/automation/admin/views/workflows/new'
import Panel from '@admin/components/panel'
import React from 'react'

const getNew = (props) => ({
  program_id: props.email_campaign.program.id,
  triggers: ['campaigns:email_received','campaigns:email_opened','campaigns:email_clicked'],
  params: {
    email_campaign_id: props.email_campaign.id
  }
})

const mapPropsToPanel = (props, context) => ({
  title: 't(ty(Workflows))',
  collection: {
    endpoint: '/api/admin/automation/workflows',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: (workflow) => (
        <WorkflowToken workflow={ workflow } compact={ true } />
      ) }
    ],
    empty: {
      title: 't(No Workflows)',
      text: 't(There are no workflows for this email campaign)',
      svg: 'network',
      buttons: props.email_campaign.deleted_at === null ? [
        { 
          label: 't(Create Workflow)',
          access: {
            programs: { $canEdit: props.email_campaign.program.id },
            rights: { $allOf: ['automation:access_app','automation:manage_workflows','campaigns:manage_email_campaigns'] }
          },
          modal: <New { ...getNew(props) } /> 
        }
      ] : null
    },
    export: [
      { label: 't(ID)', key: 'id' },
      { label: 't(Title)', key: 'display_name' },
      { label: 't(Program)', key: 'program.title' },
      { label: 't(Enrolled)', key: 'enrolled_count' },
      { label: 't(Active)', key: 'active_count' },
      { label: 't(Lost)', key: 'lost_count' },
      { label: 't(Converted)', key: 'converted_count' },
      { label: 't(Completed)', key: 'completed_count' },
      { label: 't(Status)', key: 'status' }
    ],
    entity: 'worfklow',
    defaultQuery: { email_campaign_id: props.email_campaign.id },
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/automation/workflows/${record.id}`)
  },
  task: props.email_campaign.deleted_at === null ? {
    svg: 'plus',
    access: {
      programs: { $canEdit: props.email_campaign.program.id },
      rights: { $allOf: ['automation:access_app','automation:manage_workflows','campaigns:manage_email_campaigns'] }
    },
    modal: <New { ...getNew(props) } />
  } : null
})

export default Panel(null, mapPropsToPanel)
